import { render, staticRenderFns } from "./base-checkbox.vue?vue&type=template&id=7d6db4db"
import script from "./base-checkbox.ts?vue&type=script&lang=ts&external"
export * from "./base-checkbox.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports